import { useAdminStore } from '@/stores/admin'
import { MiddlewareContext } from '.'

/**
 * Verify authentication of users on guarded routes
 * @param context `MiddlewareContext`
 * @returns `Promise<void>`
 */
export function auth(context: MiddlewareContext) {
  const logged = useAdminStore().admin != null

  if (logged) {
    return context.next()
  }

  return context.next('/login')
}
